<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">
          {{ isUpdatePage ? ('Edit User' | transloco) : ('Create User' | transloco) }}
        </span>
        <h2 class="bb-page-title">
          {{ isUpdatePage ? ('Edit User' | transloco) : ('Create User' | transloco) }}
        </h2>
      </div>
    </header>

    <form class="bb-card bb-p-20" [formGroup]="formInfo" (ngSubmit)="onSubmit()" #form="ngForm">
      <div class="bb-form-grid">

        @if(submitted && formInfo.invalid) {
        <div class="bb-form-alert bb-field-full" role="alert">
          {{ 'Review the user data before saving' | transloco }}
          @if(getMissingRequiredCount() > 0) {
          <span>
            ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
          </span>
          }
        </div>
        }

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="media">{{ "AddImage" | transloco }}</label>

          <div class="bb-upload-card">
            <input
              type="file"
              id="media"
              (change)="onFileChange($event)"
              #fileInput
              [ngModel]="mediaFiles"
              formControlName="media"
              multiple
              hidden
            />

            <div class="bb-upload-area" (click)="fileInput.click()">
              <div *ngIf="!media && !(isUpdatePage && image)" class="bb-upload-placeholder">
                <span class="bb-upload-icon">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="7" width="18" height="14" rx="3" stroke="#2A7DE1" stroke-width="2.5" />
                    <circle cx="12" cy="14" r="3.5" stroke="#2A7DE1" stroke-width="2.5" />
                    <path d="M8 7L9.5 5H14.5L16 7" stroke="#2A7DE1" stroke-width="2.5" />
                  </svg>
                </span>

                <p class="bb-upload-title">{{ "AddImage" | transloco }}</p>
                <small class="bb-upload-sub">{{ 'PNG / JPG' | transloco }}</small>
              </div>

              <div *ngIf="media || (isUpdatePage && image)" class="bb-preview-container">
                <img [src]="media ? media : fixImgUrl(image)" class="bb-preview-img" [alt]="'Preview' | transloco" />

                <button type="button" class="bb-btn bb-btn-secondary bb-btn-sm" (click)="fileInput.click(); $event.stopPropagation()">
                  {{ "change image" | transloco }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="bb-field">
          <label class="bb-label" for="Name">{{ "Full Name" | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="Name"
            formControlName="name"
            [ngModel]="first_name"
            placeholder="{{ 'Full Name' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls.name.touched && formInfo.controls.name.errors,
              'is-valid': formInfo.controls.name.touched && !formInfo.controls.name.errors,
              'is-touched': formInfo.controls.name.untouched && !formInfo.controls.name.errors,
            }"
          />
          @if(shouldShowError('name')) {
          <div class="bb-field-error">{{ getErrorMessage('name', ('Full Name' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="sname">{{ 'Invoice Name' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            [ngModel]="last_name"
            id="sname"
            formControlName="sname"
            placeholder="{{ 'Invoice Name' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls.sname.touched && formInfo.controls.sname.errors,
              'is-valid': formInfo.controls.sname.touched && !formInfo.controls.sname.errors,
              'is-touched': formInfo.controls.sname.untouched && !formInfo.controls.sname.errors,
            }"
          />
          @if(shouldShowError('sname')) {
          <div class="bb-field-error">{{ getErrorMessage('sname', ('Invoice Name' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="facebook">{{ "facebook" | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            [ngModel]="facebook_link"
            id="facebook"
            formControlName="facebook"
            placeholder="{{ 'facebook' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls.facebook.touched && formInfo.controls.facebook.errors,
              'is-valid': formInfo.controls.facebook.touched && !formInfo.controls.facebook.errors,
              'is-touched': formInfo.controls.facebook.untouched && !formInfo.controls.facebook.errors,
            }"
          />
        </div>

        <div class="bb-field">
          <label class="bb-label" for="instagram">{{ "instagram" | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            [ngModel]="instagram_link"
            id="instagram"
            formControlName="instagram"
            placeholder="{{ 'instagram' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls.instagram.touched && formInfo.controls.instagram.errors,
              'is-valid': formInfo.controls.instagram.touched && !formInfo.controls.instagram.errors,
              'is-touched': formInfo.controls.instagram.untouched && !formInfo.controls.instagram.errors,
            }"
          />
        </div>

        <div class="bb-field">
          <label class="bb-label" for="tiktok">{{ "tiktok" | transloco }}</label>
          <input
            class="bb-input"
            [ngModel]="tiktok_link"
            type="text"
            id="tiktok"
            formControlName="tiktok"
            placeholder="{{ 'tiktok' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls.tiktok.touched && formInfo.controls.tiktok.errors,
              'is-valid': formInfo.controls.tiktok.touched && !formInfo.controls.tiktok.errors,
              'is-touched': formInfo.controls.tiktok.untouched && !formInfo.controls.tiktok.errors,
            }"
          />
        </div>

        <div class="bb-field">
          <label class="bb-label" for="username">{{ 'username' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            [ngModel]="username"
            id="username"
            (ngModelChange)="saveEmail($event)"
            formControlName="username"
            placeholder="{{ 'username' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls.username.touched && formInfo.controls.username.errors,
              'is-valid': formInfo.controls.username.touched && !formInfo.controls.username.errors,
              'is-touched': formInfo.controls.username.untouched && !formInfo.controls.username.errors,
            }"
          />
          @if(shouldShowError('username')) {
          <div class="bb-field-error">{{ getErrorMessage('username', ('username' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="phone">{{ "phone" | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            [ngModel]="phone"
            id="phone"
            formControlName="phone"
            placeholder="{{ 'phone' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls.phone.touched && formInfo.controls.phone.errors,
              'is-valid': formInfo.controls.phone.touched && formInfo.controls.phone.errors == null,
              'is-touched': formInfo.controls.phone.untouched && formInfo.controls.phone.errors == null,
            }"
          />
          @if(shouldShowError('phone')) {
          <div class="bb-field-error">{{ getErrorMessage('phone', ('phone' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="Password">{{ "Password" | transloco }}</label>
          <input
            class="bb-input"
            id="Password"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="password"
            [ngModel]="read_password"
            placeholder="{{ 'Password' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls.password.touched && formInfo.controls.password.errors,
              'is-valid': formInfo.controls.password.touched && formInfo.controls.password.errors == null,
              'is-touched': formInfo.controls.password.untouched && formInfo.controls.password.errors == null,
            }"
          />
          @if(shouldShowError('password')) {
          <div class="bb-field-error">{{ getErrorMessage('password', ('Password' | transloco)) }}</div>
          }

          <button type="button" class="bb-btn bb-btn-secondary bb-w-100 bb-mt-12" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){ {{ "Show Password" | transloco }} } @else { {{ "Hide Password" | transloco }} }
          </button>
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="c_Password">{{ "Confirm Password" | transloco }}</label>
          <input
            class="bb-input"
            id="c_Password"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="c_Password"
            [ngModel]="read_password"
            placeholder="{{ 'Confirm Password' | transloco }}"
            [ngClass]="{
              'is-invalid': formInfo.controls['c_Password'].touched && formInfo.controls['c_Password'].errors,
              'is-valid': formInfo.controls['c_Password'].touched && !formInfo.controls['c_Password'].errors
            }"
          />
          @if(shouldShowError('c_Password')) {
          <div class="bb-field-error">{{ getErrorMessage('c_Password', ('Confirm Password' | transloco)) }}</div>
          }

          <button type="button" class="bb-btn bb-btn-secondary bb-w-100 bb-mt-12" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){ {{ "Show Password" | transloco }} } @else { {{ "Hide Password" | transloco }} }
          </button>
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label">{{ 'user type' | transloco }}</label>

          <div class="bb-form-grid">
            <label class="bb-card bb-p-12 bb-check-line" *ngIf="isSuperAdmin" for="SuperAdmin">
              <input class="bb-checkbox" type="radio" formControlName="type" id="SuperAdmin" value="10" />
              <span>{{ 'super admin' | transloco }}</span>
            </label>

            <label class="bb-card bb-p-12 bb-check-line" *ngIf="isAdmin || isSuperAdmin" for="admin">
              <input class="bb-checkbox" type="radio" formControlName="type" id="admin" value="1" />
              <span>{{ 'admin' | transloco }}</span>
            </label>

            <label class="bb-card bb-p-12 bb-check-line" for="subadmin">
              <input class="bb-checkbox" type="radio" formControlName="type" id="subadmin" value="6" />
              <span>{{ 'subadmin' | transloco }}</span>
            </label>

            @if(warehouseTypeService.isCompany()){

            <label class="bb-card bb-p-12 bb-check-line" for="Affiliation">
              <input class="bb-checkbox" type="radio" formControlName="type" id="Affiliation" value="2" />
              <span>{{ 'Affiliation' | transloco }}</span>
            </label>

            <label class="bb-card bb-p-12 bb-check-line" for="A">
              <input class="bb-checkbox" type="radio" formControlName="type" id="A" value="3" />
              <span>{{ 'Page A' | transloco }}</span>
            </label>

            <label class="bb-card bb-p-12 bb-check-line" for="B">
              <input class="bb-checkbox" type="radio" formControlName="type" id="B" value="4" />
              <span>{{ 'B' | transloco }}</span>
            </label>

            <label class="bb-card bb-p-12 bb-check-line" for="C">
              <input class="bb-checkbox" type="radio" formControlName="type" id="C" value="5" />
              <span>{{ 'C' | transloco }}</span>
            </label>

            <label class="bb-card bb-p-12 bb-check-line" for="client">
              <input class="bb-checkbox" type="radio" formControlName="type" id="client" value="9" />
              <span>{{ 'client' | transloco }}</span>
            </label>
            }

          </div>

          @if(shouldShowError('type')) {
          <div class="bb-field-error">{{ getErrorMessage('type', ('user type' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label">{{ 'access pages' | transloco }}</label>

          <div class="bb-form-grid">
            <label class="bb-card bb-p-12 bb-check-line" *ngFor="let page of accessPagesList">
              <input
                class="bb-checkbox"
                type="checkbox"
                [value]="page.value"
                (change)="onCheckboxChange($event)"
                [checked]="accessPages.includes(page.value)"
                [disabled]="page.value === 7 || isAffiliationSelected"
              />
              <span>{{ page.label | transloco }}</span>
            </label>
          </div>
        </div>

        <div class="bb-field-full bb-border-0"></div>

        <div class="bb-field bb-field-full bb-mt-8">
          <button type="submit" class="bb-btn bb-btn-primary bb-w-100" [class.is-disabled]="formInfo.invalid">
            @if(isUpdatePage){ {{ 'Edit' | transloco }} } @else { {{ 'Create' | transloco }} }
          </button>
        </div>

      </div>
    </form>

  </div>
</section>